
export { useDevice } from "/codebuild/output/src1535834765/src/dgbet/src/contexts/device/index.tsx"